import * as types from './types'

export const getLoanAmendments = (payload: any) => ({
  type: types.GET_LOAN_AMENDMENTS,
  payload,
})

export const getLoanAmendment = (payload: any) => ({
  type: types.GET_LOAN_AMENDMENT,
  payload,
})

export const getFacilityLoanAmendments = (payload: any) => ({
  type: types.GET_LOAN_AMENDMENTS_BY_FACILITY,
  payload,
})

export const startLoadingFacilityLoanAmendments = () => ({
  type: types.START_LOADING_FACILITY_LOAN_AMENDMENTS,
})

export const stopLoadingFacilityLoanAmendments = () => ({
  type: types.STOP_LOADING_FACILITY_LOAN_AMENDMENTS,
})

export const addLoanAmendment = (payload: any) => ({
  type: types.ADD_LOAN_AMENDMENTS,
  payload,
})

export const editLoanAmendment = (payload: any) => ({
  type: types.EDIT_LOAN_AMENDMENTS,
  payload,
})

export const submitLoanAmendment = (payload: any) => ({
  type: types.SUBMIT_LOAN_AMENDMENT,
  payload,
})

export const rejectLoanAmendment = (payload: any) => ({
  type: types.REJECT_LOAN_AMENDMENT,
  payload,
})

export const approveLoanAmendment = (payload: any) => ({
  type: types.APPROVE_LOAN_AMENDMENT,
  payload,
})

export const deleteLoanAmendment = (payload: any) => ({
  type: types.DELETE_LOAN_AMENDMENT,
  payload,
})

export const startLoadingLoanAmendments = () => ({
  type: types.START_LOADING_LOAN_AMENDMENTS,
  payload: null,
})

export const stopLoadingLoanAmendments = () => ({
  type: types.STOP_LOADING_LOAN_AMENDMENTS,
  payload: null,
})
